import { makeStyles } from '@mui/styles';



export const useStyles_LandingPage = makeStyles((theme) => ({
  root: {
    height: "10px",
    backgroundColor: "#413e40",
  },
  moveToFront: {
    [theme.breakpoints.down('md')]: {
      order: -1,
    },
  },
}));

// export { useStyles_LandingPage };

// New styles (was useStyles2)
export const useStyles2_LandingPage = makeStyles((theme) => {
    const rowHeight = 400; // define here to fix no-undef
    return {
        fullWidth: {
            display: "block",
            margin: "auto",
            width: "100%",
        },
        appStore: {
            display: "block",
            margin: "0 auto",
            [theme.breakpoints.down('md')]: {
                width: "80%",
            },
        },
        jigpaws: {
            backgroundColor: "#413e40",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
        },
        linebreak1: {
            backgroundColor: '#85a2ad',
            height: "1.5vh",
            filter: "brightness(90%)"
        },
        linebreak2: {
            backgroundColor: '#413e40',
            height: "1.5vh",
        },
        see: {
            minHeight: rowHeight,
            height: "calc(40vh - 67px)",
            backgroundColor: "#99bfc2",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            [theme.breakpoints.down('md')]: {
                height: "25vh",
                minHeight: 0,
            },
        },
        download: {
            minHeight: rowHeight,
            backgroundColor: "#85a2ad",
            color: "#fff",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            [theme.breakpoints.down('md')]: {
                height: "25vh",
                minHeight: 0,
            },
        },
        transparentDivider: {
            height: "5vh",
            backgroundColor: "#fff",
        },
        galleryLink: {
            paddingTop: 10
        },
        moveToFront: {
            [theme.breakpoints.down('md')]: {
                order: -1,
            },
        }
    };
});

// Button styles
export const buttonStyles = {
    padding: '10px 30px',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.05em",
    border: "1px solid "
};

// Body styles
export const bodyStyle = {
    fontSize: '20px',
    '@media (max-height: 600px)': {
        fontSize: '16px',
    },
};